import React from 'react';
import Layout from '../../components/Layout';
import HeroFragment from './HeroFragment';

const NotFound = () => {
  return <Layout hero={<HeroFragment />} />;
};
export default NotFound;
